'use strict';

angular
	.module('dcApp')
	.controller('UserListController', [
		'PermissionService',
		'$timeout',
		'$scope',
		'$state',
		'$rootScope',
		'toaster',
		'UserService',
		'PAGINATIONS_SIZES',
		'PAGINATIONS_SIZE',
		'$q',
		'permissionChecker',
		'gettextCatalog',
		function (
			PermissionService,
			$timeout,
			$scope,
			$state,
			$rootScope,
			toaster,
			UserService,
			PAGINATIONS_SIZES,
			PAGINATIONS_SIZE,
			$q,
			permissionChecker,
			gettextCatalog
		) {
			let dataGirdColumnName = {};
			dataGirdColumnName.lastName = gettextCatalog.getString('Nom');
			dataGirdColumnName.firstName = gettextCatalog.getString('Prénom');
			dataGirdColumnName.username = gettextCatalog.getString(
				"Nom de l'utilisateur"
			);
			dataGirdColumnName.locked = gettextCatalog.getString('Verrouillé');
			dataGirdColumnName.effectiveDate =
				gettextCatalog.getString("Date d'effet");
			dataGirdColumnName.actions = gettextCatalog.getString('Actions');
			dataGirdColumnName.roles = gettextCatalog.getString('role');
			dataGirdColumnName.enabled = gettextCatalog.getString('Actif');

			$scope.userLogoutData = {};

			$scope.confirmUserLogoutData = {};

			$scope.hasDefaultUserRoleActive = $rootScope.hasDefaultUserRoleActive;

			$scope.userLogoutData.confirmLogout = function (userId) {
				$scope.confirmUserLogoutData.userId = userId;
				$scope.confirmUserLogoutData.showConfirmUserLogout = true;
			};

			function getListUsers(refresh) {
				return UserService.getUsers($scope.active, refresh);
			}

			$scope.getGridData = function (refresh) {
				$scope.showGrid = false;
				getListUsers(refresh).then(function (users) {
					if (users !== undefined) {
						$scope.users = users;
						$scope.usersGridData = $scope.users;
						$scope.dataGridOptions.dataSource = $scope.usersGridData;
						$scope.showGrid = true;
					}
				});
			};

			$scope.dataGridOptions = {
				dataSource: $scope.usersGridData,
				paging: {
					enabled: true,
					pageSize: PAGINATIONS_SIZE,
				},
				pager: {
					showPageSizeSelector: true,
					allowedPageSizes: PAGINATIONS_SIZES,
					showInfo: true,
					visible: true,
				},
				searchPanel: {
					visible: true,
					width: 240,
				},
				filterRow: {
					visible: true,
					applyFilter: 'auto',
				},
				rowAlternationEnabled: true,
				headerFilter: {
					visible: true,
					applyFilter: 'auto',
				},
				showColumnLines: true,
				showRowLines: true,
				allowColumnReordering: true,
				allowColumnResizing: true,
				columnAutoWidth: true,
				showBorders: true,
				columnChooser: {
					enabled: true,
				},
				columnFixing: {
					enabled: true,
				},
				columns: [
					{
						caption: dataGirdColumnName.lastName,
						dataField: 'last_name',
						cellTemplate: 'clickableCell',
					},
					{
						caption: dataGirdColumnName.firstName,
						dataField: 'first_name',
						cellTemplate: 'clickableCell',
					},
					{
						caption: dataGirdColumnName.username,
						dataField: 'username',
						cellTemplate: 'clickableCell',
					},
					{
						caption: dataGirdColumnName.roles,
						alignment: 'center',
						cellTemplate: 'userRoles',
						allowReordering: false,
					},
					{
						caption: dataGirdColumnName.enabled,
						dataField: 'enabled',
					},
					{
						caption: dataGirdColumnName.actions,
						alignment: 'center',
						cellTemplate: 'actions',
						width: 220,
						allowReordering: false,
					},
				],
				onInitialized: function (e) {
					$scope.gridInstance = e.component;
				},
			};

			function initUsers() {
				$scope.getGridData();
			}

			$scope.refreshUserList = function () {
				$scope.showGrid = false;
				$scope.getGridData(true);
			};

			permissionChecker.checkGlobalPermission(
				'users',
				function () {
					initUsers();
				},
				function () {
					$scope.users_unauthorised = true;
				}
			);
		},
	])
	.controller('EditUserController', [
		'$stateParams',
		'$state',
		'$timeout',
		'$scope',
		'$rootScope',
		'$filter',
		'toaster',
		'UserService',
		'GenericService',
		'PAGINATIONS_SIZES',
		'PAGINATIONS_SIZE',
		'DATE_PATTERN',
		'UserGroupService',
		'gettextCatalog',
		function (
			$stateParams,
			$state,
			$timeout,
			$scope,
			$rootScope,
			$filter,
			toaster,
			UserService,
			GenericService,
			PAGINATIONS_SIZES,
			PAGINATIONS_SIZE,
			DATE_PATTERN,
			UserGroupService,
			gettextCatalog
		) {
			let dataGirdColumnName = {};
			dataGirdColumnName.label = gettextCatalog.getString('Libellé');
			dataGirdColumnName.all = gettextCatalog.getString('Tout');

			let toasterPopPermission = gettextCatalog.getString('Permission');
			let toasterPopNoAuthorizedAction = gettextCatalog.getString(
				'Action non autorisée'
			);
			let userTypePerson = gettextCatalog.getString('Personne');
			let userTypeSystem = gettextCatalog.getString('Système');

			$scope.disableUser = gettextCatalog.getString("Désactiver l'utilisateur");
			$scope.enableUser = gettextCatalog.getString("Activer l'utilisateur");
			$rootScope.fields = [];
			$scope.attemptConnexion = [
				{ value: 1, label: '1' },
				{ value: 2, label: '2' },
				{ value: 3, label: '3' },
			];
			$scope.attemptPassword = [
				{ value: 1, label: '1' },
				{ value: 2, label: '2' },
				{ value: 3, label: '3' },
			];
			$scope.types = [
				{ value: 1, label: userTypePerson },
				{ value: 2, label: userTypeSystem },
			];
			$scope.selectedTryPasswordKo = 3;
			$scope.selectedTryPasswordQuestionKo = 3;
			$scope.userLogoutData = {};
			$scope.confirmUserLogoutData = {};
			$scope.permissionData = {};

			$scope.userLogoutData.confirmLogout = function (userId) {
				$scope.confirmUserLogoutData.userId = userId;
				$scope.confirmUserLogoutData.showConfirmUserLogout = true;
			};

			$scope.redirectionToList = function () {
				$timeout(function () {
					$state.go('users');
				}, 300);
			};

			// Set old state
			UserService.setOldState($state.current.name);

			init();

			function init() {
				if ($rootScope.userIsAdmin) {
					var userId = $stateParams.id;
					UserService.getUser(userId).then(function (user) {
						$scope.currentUser = user;
					});
				} else {
					toaster.pop(
						'error',
						toasterPopPermission,
						toasterPopNoAuthorizedAction
					);
					$state.go('users');
				}
			}

			function createList(selector, items, isForUserGroups) {
				var list = $(selector)
					.dxList({
						items: items,
						repaintChangesOnly: true,
						keyExpr: 'id',
						displayExpr: 'label',
					})
					.dxList('instance');
			}

			$scope.getGlobalPermissions = function () {
				$scope.userTabHidden = true;
				$scope.showGlobalPermissions = true;
			};

			$scope.getElementPermissions = function () {
				$scope.userTabHidden = true;
				$scope.showElementPermissions = true;
			};

			$scope.getUserGroups = function () {
				$scope.userTabHidden = true;
				UserGroupService.getGroupsByUser($scope.currentUser.id).then(function (
					response
				) {
					const userGroups = response.data;
					UserGroupService.getGroups().then(function (availableGroupsResponse) {
						var availableGroups = _.filter(
							availableGroupsResponse,
							function (item) {
								return !_.filter(userGroups, function (group) {
									return group.id === item.id;
								})[0];
							}
						);
						createList('#availableGroups', availableGroups);
						createList('#userGroups', userGroups, true);
					});
				});
			};
		},
	]);
